export default {
      id: "graph-cn-usage",
      viewBox: "0 0 153 178",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-cn",
      toString: function () {
        return this.url;
      }
    }